import { useEffect, useState } from "react";
import { TextInput } from "components/UI/ComplexComponents/TextInput";
import { DropdownSelect } from "components/UI/ComplexComponents/DropdownSelect";
import StudentDataComponentTranslation from "../translations/StudentDataComponentTranslation";
import DatePicker from "react-datepicker";
import { getCookie, parseDMY } from '../../../../Common/CommonFunctions';

function StudentDataComponent({ children, langCode, handleStep, studentStudiesForm, setStudentStudiesForm, countries, cities, view, saveDraft }) {


    const [user, setUser] = useState(JSON.parse(getCookie("user").split(';').reduce((cookieObject, cookieString) => {
        let splitCookie = cookieString.split('=').map((cookiePart) => { cookiePart.trim() })
        try {
            cookieObject[splitCookie[0]] = JSON.parse(splitCookie[1])
        } catch (error) {
            cookieObject[splitCookie[0]] = splitCookie[1]
        }
        return cookieObject
    })))

    const initialState = {
        nameGreek: user?.given_name_gr,
        familyNameGreek: user?.family_name_gr,
        nameLatin: user?.given_name,
        familyNameLatin: user?.family_name,
        email: user?.email,
        gender: "",
        birthDate: "",
        birthCountry: "",
        birthCity: "",
        citizenship: "",
        identificationNumber: "",
        identificationIssueDate: "",
        identificationIssueAuthority: "",
        fatherName: "",
        motherName: "",
        taxAuthority: "",
        taxpayerIdNumber: "",
        SocialSecurityNumber: "",
        phoneLandline: "",
        phoneMobile: "",
        street: "",
        postalCode: "",
        city: "",
        country: "",
        phoneNumber: "",
        currentStreet: "",
        currentPostalCode: "",
        currentCity: "",
        currentCountry: "",
        emergencyContactName: "",
        emergencyContactPhone: "",
        emergencyContactMail: ""
    }

    const [studentData, setStudentData] = useState(initialState)
    const required = true

    function setFieldValue(setterFunc) {

        return function (item, value) {
            setterFunc({ ...studentData, [item]: value })
        }
    }

    useEffect(() => {
        if (studentStudiesForm?.studentData !== undefined) {

            if (studentStudiesForm?.studentData[0] !== undefined) {
                const temp = JSON.parse(JSON.stringify(studentStudiesForm?.studentData[0]))
                console.log(temp)
                console.log(studentStudiesForm?.studentData)

                let citizenshipTemp = countries.filter(country => country.countryCode === temp.citizenship.countryCode)[0]
                let birthCountryTemp = countries.filter(country => country.countryCode === temp.birthCountry.countryCode)[0]
                let countryFixedTemp = countries.filter(country => country.countryCode === studentStudiesForm?.studentData[0].fixAddr[0].country.countryCode)[0]
                let countryTemporaryTemp = ''
                if (studentStudiesForm?.studentData[0].tempAddr[0]?.country !== null && studentStudiesForm?.studentData[0].tempAddr[0]?.country !== undefined) {
                    countryTemporaryTemp = countries.filter(country => country.countryCode === studentStudiesForm?.studentData[0].tempAddr[0].country.countryCode)[0]
                } else {
                    countryTemporaryTemp = ""
                }

                console.log(citizenshipTemp, birthCountryTemp, countryFixedTemp, countryTemporaryTemp)

                if (langCode === "gr") {
                    temp['citizenship'] = citizenshipTemp.countryNameGR
                    temp['birthCountry'] = birthCountryTemp.countryNameGR
                    temp['country'] = countryFixedTemp.countryNameGR
                    temp['currentCountry'] = countryTemporaryTemp?.countryNameGR ? countryTemporaryTemp?.countryNameGR : ''
                } else {
                    temp['citizenship'] = citizenshipTemp.countryName
                    temp['birthCountry'] = birthCountryTemp.countryName
                    temp['country'] = countryFixedTemp.countryName
                    temp['currentCountry'] = countryTemporaryTemp?.countryName ? countryTemporaryTemp?.countryName : ''
                }

                console.log(temp.fixAddr[0])
                console.log(temp.tempAddr[0])

                temp['street'] = temp.fixAddr[0].street
                temp['postalCode'] = temp.fixAddr[0].postalCode
                temp['city'] = temp.fixAddr[0].city
                temp['phoneNumber'] = temp.fixAddr[0].phoneNumber

                temp['currentStreet'] = temp.tempAddr[0].street
                temp['currentPostalCode'] = temp.tempAddr[0].postalCode
                temp['currentCity'] = temp.tempAddr[0].city
                // temp['currentCountry'] = temp.addressTemporary[0]?.country?.countryName ? temp.addressTemporary[0]?.country?.countryName : ''

                if (langCode === "gr") {
                    temp['gender'] = temp.gender === 1 ? 'Άνδρας' : temp.gender === 2 ? 'Γυναίκα' : 'Άλλο'
                } else {
                    temp['gender'] = temp.gender === 1 ? 'Male' : temp.gender === 2 ? 'Female' : 'Other'
                }

                console.log(new Date(temp['birthDate']).toISOString().replace(/T.*/, '').split('-').reverse().join('/'))
                const birthDateTemp = new Date(temp['birthDate'])

                temp['birthDate'] = birthDateTemp.toISOString().replace(/T.*/, '').split('-').reverse().join('/')

                const identificationIssueDateTemp = new Date(temp['identificationIssueDate'])

                temp['identificationIssueDate'] = identificationIssueDateTemp.toISOString().replace(/T.*/, '').split('-').reverse().join('/')

                delete temp['tempAddr']
                delete temp['fixAddr']

                console.log(temp)
                console.log(studentStudiesForm?.studentData)
                setStudentData(temp)
            }
        } else {
            setStudentData(initialState)
        }
    }, [])

    useEffect(() => {
        console.log(studentData)
    }, [])


    return (
        <form className="g-3 needs-validation" noValidate={false} onSubmit={async (event) => {
            event.preventDefault();

            if (!view) {
                let gender = ""
                let birthCountry = { id: '', countryCode: '', countryName: '' }
                let citizenship = { id: '', countryCode: '', countryName: '' }
                let country = { id: '', countryCode: '', countryName: '' }
                let currentCountry = { id: '', countryCode: '', countryName: '' }

                if (langCode === "gr") {
                    gender = studentData.gender === 'Άνδρας' ? 1 : studentData.gender === 'Γυναίκα' ? 2 : 0
                    if (countries.find((i) => i.countryNameGR === studentData.birthCountry) !== undefined) {
                        birthCountry = countries.find((i) => i.countryNameGR === studentData.birthCountry)
                    }


                    if (countries.find((i) => i.countryNameGR === studentData.citizenship) !== undefined) {
                        citizenship = countries.find((i) => i.countryNameGR === studentData.citizenship)
                    }


                    if (countries.find((i) => i.countryNameGR === studentData.country) !== undefined) {
                        country = countries.find((i) => i.countryNameGR === studentData.country)
                    }

                    if (countries.find((i) => i.countryNameGR === studentData.currentCountry) !== undefined) {
                        currentCountry = countries.find((i) => i.countryNameGR === studentData.currentCountry)
                    } else {
                        currentCountry = null
                    }
                } else {
                    gender = studentData.gender === 'Male' ? 1 : studentData.gender === 'Female' ? 2 : 0
                    if (countries.find((i) => i.countryName === studentData.birthCountry) !== undefined) {
                        birthCountry = countries.find((i) => i.countryName === studentData.birthCountry)
                    }


                    if (countries.find((i) => i.countryName === studentData.citizenship) !== undefined) {
                        citizenship = countries.find((i) => i.countryName === studentData.citizenship)
                    }


                    if (countries.find((i) => i.countryName === studentData.country) !== undefined) {
                        country = countries.find((i) => i.countryName === studentData.country)
                    }

                    if (countries.find((i) => i.countryName === studentData.currentCountry) !== undefined) {
                        currentCountry = countries.find((i) => i.countryName === studentData.currentCountry)
                    } else {
                        currentCountry = null
                    }
                }

                const addressFixed = [{
                    street: studentData.street,
                    postalCode: studentData.postalCode,
                    city: studentData.city,
                    country: country,
                    phoneNumber: studentData.phoneNumber
                }]

                const addressTemporary = [{
                    street: studentData.currentStreet,
                    postalCode: studentData.currentPostalCode,
                    city: studentData.currentCity,
                    country: currentCountry,
                }]

                console.log(addressTemporary)

                const studentDataTemp = { ...studentData };

                var tempDateString = studentDataTemp.birthDate;
                console.log(tempDateString)
                var dateParts = tempDateString.split("/");
                console.log(dateParts)

                var birthDateTemp = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0] + 1)
                console.log(birthDateTemp)
                console.log(birthDateTemp.toISOString())

                studentDataTemp['birthDate'] = birthDateTemp.toISOString()

                var tempDateString = studentDataTemp.identificationIssueDate;
                var dateParts = tempDateString.split("/");

                var identificationIssueDateTemp = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0] + 1)
                console.log(identificationIssueDateTemp.toISOString())

                studentDataTemp['identificationIssueDate'] = identificationIssueDateTemp.toISOString()

                delete studentDataTemp.street
                delete studentDataTemp.postalCode
                delete studentDataTemp.city
                delete studentDataTemp.country

                delete studentDataTemp.currentStreet
                delete studentDataTemp.currentPostalCode
                delete studentDataTemp.currentCity
                delete studentDataTemp.currentCountry
                delete studentDataTemp.phoneNumber

                studentDataTemp['gender'] = gender
                studentDataTemp['birthCountry'] = birthCountry
                studentDataTemp['citizenship'] = citizenship
                studentDataTemp['fixAddr'] = addressFixed
                studentDataTemp['tempAddr'] = addressTemporary
                // localStorage.setItem('studentData', JSON.stringify({ studentData: studentDataTemp }))
                setStudentStudiesForm({ ...studentStudiesForm, studentData: [studentDataTemp] })
                var activeElement = document.activeElement;
                if (activeElement.value === 'draft') {
                    saveDraft({ ...studentStudiesForm, studentData: [studentDataTemp] })
                } else {
                    handleStep();
                }
            } else {
                handleStep()
            }
        }}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card p-4">
                            <h3 className="text-center">{StudentDataComponentTranslation("h3_title", langCode)['label']}</h3>
                            <div className="form-group">
                                <h5 className="text-left">{StudentDataComponentTranslation("h5_personalData", langCode)['label']}</h5>
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.familyNameGreek,
                                        inputLabel: StudentDataComponentTranslation("familyNameGreek", langCode)['label'],
                                        componentId: "familyNameGreek",
                                        disabled: true,
                                        type: "text",

                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.nameGreek,
                                        inputLabel: StudentDataComponentTranslation("nameGreek", langCode)['label'],
                                        componentId: "nameGreek",
                                        disabled: true,
                                        type: "text",

                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.familyNameLatin,
                                        inputLabel: StudentDataComponentTranslation("familyNameLatin", langCode)['label'],
                                        componentId: "familyNameLatin",
                                        disabled: true,
                                        type: "text",

                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.nameLatin,
                                        inputLabel: StudentDataComponentTranslation("nameLatin", langCode)['label'],
                                        componentId: "nameLatin",
                                        disabled: true,
                                        type: "text",

                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.email,
                                        inputLabel: StudentDataComponentTranslation("email", langCode)['label'],
                                        componentId: "email",
                                        type: "text",
                                        required: required,
                                        disabled: true
                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: StudentDataComponentTranslation("gender_options", langCode),
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.gender,
                                        selectLabel: StudentDataComponentTranslation("gender", langCode)['label'],
                                        placeholderText: StudentDataComponentTranslation("gender", langCode)['placeholder'],
                                        componentId: "gender",
                                        required: required,
                                        disabled: view

                                    })
                                }
                                <div className="form-group">
                                    <label for="birthDate">{StudentDataComponentTranslation("birthDate", langCode)['label']}</label>
                                    <DatePicker required={required} selected={studentData.birthDate ? parseDMY(studentData.birthDate) : null} dateFormat="dd/MM/yyyy" onChange={(e) => {
                                        if (e !== null) {
                                            setStudentData({ ...studentData, birthDate: e.toLocaleDateString('el-GR', { day: 'numeric', month: 'numeric', year: 'numeric' }) })
                                        }
                                        else {
                                            setStudentData({ ...studentData, birthDate: null })
                                        }
                                    }} className="form-control" popperPlacement='bottom' disabled={view} />
                                </div>
                                {
                                    DropdownSelect({
                                        optionsList: countries ? langCode === "en" ? countries.map(i => ({ label: i?.countryName, value: i?.id })) : langCode === "gr" ? countries.map(i => ({ label: i?.countryNameGR, value: i?.id })) : [] : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.birthCountry,
                                        selectLabel: StudentDataComponentTranslation("birthCountry", langCode)['label'],
                                        componentId: "birthCountry",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.birthCity,
                                        inputLabel: StudentDataComponentTranslation("placeOfBirth", langCode)['label'],
                                        componentId: "birthCity",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {/* {
                                    DropdownSelect({
                                        optionsList: [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.nationality,
                                        selectLabel: StudentDataComponentTranslation("nationality", langCode)['label'],
                                        componentId: "nationality",
                                        required: required
                                    })
                                } */}
                                {
                                    DropdownSelect({
                                        optionsList: countries ? langCode === "en" ? countries.map(i => ({ label: i?.countryName, value: i?.id })) : langCode === "gr" ? countries.map(i => ({ label: i?.countryNameGR, value: i?.id })) : [] : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.citizenship,
                                        selectLabel: StudentDataComponentTranslation("citizenship", langCode)['label'],
                                        componentId: "citizenship",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.identificationNumber,
                                        inputLabel: StudentDataComponentTranslation("identityNumber", langCode)['label'],
                                        componentId: "identificationNumber",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                <div className="form-group">
                                    <label for="identificationIssueDate">{StudentDataComponentTranslation("identificationIssueDate", langCode)['label']}</label>
                                    <DatePicker required={required} selected={studentData.identificationIssueDate ? parseDMY(studentData.identificationIssueDate) : null} dateFormat="dd/MM/yyyy" onChange={(e) => {
                                        if (e !== null) {
                                            setStudentData({ ...studentData, identificationIssueDate: e.toLocaleDateString('el-GR', { day: 'numeric', month: 'numeric', year: 'numeric' }) })
                                        } else {
                                            setStudentData({ ...studentData, identificationIssueDate: null })
                                        }
                                    }} className="form-control" popperPlacement='bottom' disabled={view} />

                                </div>
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.identificationIssueAuthority,
                                        inputLabel: StudentDataComponentTranslation("identityAuthority", langCode)['label'],
                                        componentId: "identificationIssueAuthority",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.fatherName,
                                        inputLabel: StudentDataComponentTranslation("fathersName", langCode)['label'],
                                        componentId: "fatherName",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.motherName,
                                        inputLabel: StudentDataComponentTranslation("mothersName", langCode)['label'],
                                        componentId: "motherName",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: [{ label: "Α' ΑΘΗΝΩΝ" }, { label: "Α' ΠΕΙΡΑΙΑ" }, { label: "ΑΓΙΟΥ ΝΙΚΟΛΑΟΥ" }, { label: "ΑΓΙΩΝ ΑΝΑΡΓΥΡΩΝ" }, { label: "ΑΓΡΙΝΙΟΥ" }, { label: "ΑΙΓΑΛΕΩ" }, { label: "ΑΙΓΙΟΥ" }, { label: "ΑΛΕΞΑΝΔΡΟΥΠΟΛΗΣ" }, { label: "ΑΜΑΛΙΑΔΑΣ" }, { label: "ΑΜΑΡΟΥΣΙΟΥ" }, { label: "ΑΜΠΕΛΟΚΗΠΩΝ" }, { label: "ΑΜΦΙΣΣΑΣ" }, { label: "ΑΡΓΟΣΤΟΛΙΟΥ" }, { label: "ΑΡΓΟΥΣ" }, { label: "ΑΡΤΑΣ" }, { label: "ΒΕΡΟΙΑΣ" }, { label: "ΒΟΛΟΥ" }, { label: "ΓΙΑΝΝΙΤΣΩΝ" }, { label: "ΓΛΥΦΑΔΑΣ" }, { label: "ΓΡΕΒΕΝΩΝ" }, { label: "Δ' ΑΘΗΝΩΝ" }, { label: "Δ' ΘΕΣΣΑΛΟΝΙΚΗΣ" }, { label: "ΔΡΑΜΑΣ" }, { label: "Ε' ΘΕΣΣΑΛΟΝΙΚΗΣ" }, { label: "Ε' ΠΕΙΡΑΙΑ" }, { label: "ΕΔΕΣΣΑΣ" }, { label: "ΕΛΕΥΣΙΝΑΣ" }, { label: "Ζ' ΘΕΣΣΑΛΟΝΙΚΗΣ" }, { label: "ΖΑΚΥΝΘΟΥ" }, { label: "ΗΓΟΥΜΕΝΙΤΣΑΣ" }, { label: "ΗΛΙΟΥΠΟΛΗΣ" }, { label: "ΗΡΑΚΛΕΙΟΥ" }, { label: "ΗΡΑΚΛΕΙΟΥ" }, { label: "ΘΗΒΩΝ" }, { label: "ΘΗΡΑΣ" }, { label: "ΘΗΡΑΣ" }, { label: "ΙΒ' ΑΘΗΝΩΝ" }, { label: "ΙΓ' ΑΘΗΝΩΝ" }, { label: "ΙΖ' ΑΘΗΝΩΝ" }, { label: "ΙΩΑΝΝΙΝΩΝ" }, { label: "ΙΩΝΙΑΣ ΘΕΣΣΑΛΟΝΙΚΗΣ" }, { label: "ΚΑΒΑΛΑΣ" }, { label: "ΚΑΛΑΜΑΡΙΑΣ" }, { label: "ΚΑΛΑΜΑΤΑΣ" }, { label: "ΚΑΛΛΙΘΕΑΣ" }, { label: "ΚΑΡΔΙΤΣΑΣ" }, { label: "ΚΑΡΠΕΝΗΣΙΟΥ" }, { label: "ΚΑΣΤΟΡΙΑΣ" }, { label: "ΚΑΤΕΡΙΝΗΣ" }, { label: "ΚΑΤΟΙΚΩΝ  ΕΞΩΤΕΡΙΚΟΥ" }, { label: "ΚΕΡΚΥΡΑΣ" }, { label: "ΚΗΦΙΣΙΑΣ" }, { label: "ΚΙΛΚΙΣ" }, { label: "ΚΟΖΑΝΗΣ" }, { label: "ΚΟΖΑΝΗΣ" }, { label: "ΚΟΜΟΤΗΝΗΣ" }, { label: "ΚΟΡΙΝΘΟΥ" }, { label: "ΚΟΡΩΠΙΟΥ" }, { label: "ΚΥΜΗΣ" }, { label: "ΚΩ" }, { label: "ΛΑΓΚΑΔΑ" }, { label: "ΛΑΜΙΑΣ" }, { label: "ΛΑΡΙΣΑΣ" }, { label: "ΛΕΥΚΑΔΑΣ" }, { label: "ΛΙΒΑΔΕΙΑΣ" }, { label: "ΜΕΓΑΛΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ" }, { label: "ΜΕΣΟΛΟΓΓΙΟΥ" }, { label: "ΜΥΚΟΝΟΥ" }, { label: "ΜΥΤΙΛΗΝΗΣ" }, { label: "ΝΑΞΟΥ" }, { label: "ΝΑΥΠΛΙΟΥ" }, { label: "ΝΕΑΣ ΙΩΝΙΑΣ" }, { label: "ΝΕΩΝ ΜΟΥΔΑΝΙΩΝ" }, { label: "ΝΙΚΑΙΑΣ" }, { label: "ΞΑΝΘΗΣ" }, { label: "ΟΡΕΣΤΙΑΔΑΣ" }, { label: "ΠΑΛΛΗΝΗΣ" }, { label: "ΠΑΡΟΥ" }, { label: "ΠΑΤΡΩΝ" }, { label: "ΠΕΡΙΣΤΕΡΙΟΥ" }, { label: "ΠΛΟΙΩΝ ΠΕΙΡΑΙΑ" }, { label: "ΠΟΛΥΓΥΡΟΥ" }, { label: "ΠΡΕΒΕΖΑΣ" }, { label: "ΠΤΟΛΕΜΑΙΔΑΣ" }, { label: "ΠΥΡΓΟΥ" }, { label: "ΡΕΘΥΜΝΟΥ" }, { label: "ΡΟΔΟΥ" }, { label: "ΣΑΜΟΥ" }, { label: "ΣΕΡΡΩΝ" }, { label: "ΣΠΑΡΤΗΣ" }, { label: "ΣΥΡΟΥ" }, { label: "ΤΡΙΚΑΛΩΝ" }, { label: "ΤΡΙΠΟΛΗΣ" }, { label: "Φ.Α.Ε. ΑΘΗΝΩΝ" }, { label: "ΦΑΕ ΘΕΣΣΑΛΟΝΙΚΗΣ" }, { label: "ΦΑΕ ΠΕΙΡΑΙΑ" }, { label: "ΦΛΩΡΙΝΑΣ" }, { label: "ΧΑΛΚΙΔΑΣ" }, { label: "ΧΑΝΙΩΝ" }, { label: "ΧΙΟΥ" }, { label: "ΧΟΛΑΡΓΟΥ" }, { label: "ΨΥΧΙΚΟΥ" }],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.taxAuthority,
                                        selectLabel: StudentDataComponentTranslation("publicFinanceService", langCode)['label'],
                                        componentId: "taxAuthority",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.taxpayerIdNumber,
                                        inputLabel: StudentDataComponentTranslation("taxIdentificationNumber", langCode)['label'],
                                        componentId: "taxpayerIdNumber",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.SocialSecurityNumber,
                                        inputLabel: StudentDataComponentTranslation("socialSecurityRegistrationNumber", langCode)['label'],
                                        componentId: "SocialSecurityNumber",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.phoneLandline,
                                        inputLabel: StudentDataComponentTranslation("homePhoneNumber", langCode)['label'],
                                        componentId: "phoneLandline",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.phoneMobile,
                                        inputLabel: StudentDataComponentTranslation("mobilePhoneNumber", langCode)['label'],
                                        componentId: "phoneMobile",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                <h5 className="text-left">{StudentDataComponentTranslation("h5_permanentAddress", langCode)['label']}</h5>
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.street,
                                        inputLabel: StudentDataComponentTranslation("street", langCode)['label'],
                                        componentId: "street",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.postalCode,
                                        inputLabel: StudentDataComponentTranslation("postalCode", langCode)['label'],
                                        componentId: "postalCode",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: cities ? cities.map(i => ({ label: i?.cityName })) : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.city,
                                        selectLabel: StudentDataComponentTranslation("city", langCode)['label'],
                                        componentId: "city",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: countries ? langCode === "en" ? countries.map(i => ({ label: i?.countryName, value: i?.id })) : langCode === "gr" ? countries.map(i => ({ label: i?.countryNameGR, value: i?.id })) : [] : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.country,
                                        selectLabel: StudentDataComponentTranslation("country", langCode)['label'],
                                        componentId: "country",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.phoneNumber,
                                        inputLabel: StudentDataComponentTranslation("phoneNumber", langCode)['label'],
                                        componentId: "phoneNumber",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                <h5 className="text-left">{StudentDataComponentTranslation("h5_currentAddress", langCode)['label']}</h5>
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.currentStreet,
                                        inputLabel: StudentDataComponentTranslation("currentStreet", langCode)['label'],
                                        componentId: "currentStreet",
                                        type: "text",
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.currentPostalCode,
                                        inputLabel: StudentDataComponentTranslation("currentPostalCode", langCode)['label'],
                                        componentId: "currentPostalCode",
                                        type: "text",
                                        disabled: view

                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: cities ? cities.map(i => ({ label: i?.cityName })) : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.currentCity,
                                        selectLabel: StudentDataComponentTranslation("currentCity", langCode)['label'],
                                        componentId: "currentCity",
                                        disabled: view
                                    })
                                }
                                {
                                    DropdownSelect({
                                        optionsList: countries ? langCode === "en" ? countries.map(i => ({ label: i?.countryName, value: i?.id })) : langCode === "gr" ? countries.map(i => ({ label: i?.countryNameGR, value: i?.id })) : [] : [],
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.currentCountry,
                                        selectLabel: StudentDataComponentTranslation("currentCountry", langCode)['label'],
                                        componentId: "currentCountry",
                                        disabled: view
                                    })
                                }
                                <h5 className="text-left">{StudentDataComponentTranslation("h5_emergencyDetails", langCode)['label']}</h5>
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.emergencyContactName,
                                        inputLabel: StudentDataComponentTranslation("emergencyName", langCode)['label'],
                                        componentId: "emergencyContactName",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.emergencyContactMail,
                                        inputLabel: StudentDataComponentTranslation("emergencyEmail", langCode)['label'],
                                        componentId: "emergencyContactMail",
                                        type: "text",
                                        disabled: view
                                    })
                                }
                                {
                                    TextInput({
                                        parentSetValueSelected: setFieldValue(setStudentData),
                                        parentValueSelected: studentData.emergencyContactPhone,
                                        inputLabel: StudentDataComponentTranslation("emergencyPhone", langCode)['label'],
                                        componentId: "emergencyContactPhone",
                                        type: "text",
                                        required: required,
                                        disabled: view
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {children}
        </form>
    );
}
export default StudentDataComponent